import React from 'react';
import { HeadingBlockContainerProps } from './headingBlockProps';
import { ReportingContainerBaseConfig } from '../../base';
import { HeadingBlockController, HeadingBlockLoader } from './headingBlockInterface';

export function createHeadingBlockContainer(
    config: ReportingContainerBaseConfig,
    loader: HeadingBlockLoader,
    controller: HeadingBlockController
): React.FC<HeadingBlockContainerProps> {
    const {
        context: { useContext },
    } = config;
    return ({ as: View, children, ...containerProps }) => {
        const context = {
            root: useContext(),
            block: config.infra.editor.context.useContext(),
        };
        const data = loader.useLoad(context.root, containerProps);
        const props = controller.useProps(context.root, data, {
            item: {
                adapter: context.block.adapter,
            },
            level: containerProps.level,
        });
        return <View {...props}>{children}</View>;
    };
}
